import "../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { hasInstance as m } from "./utils.js";
import { reactive as y, readonly as h } from "../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { off as s, on as c } from "../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
import { onBeforeMount as w, onBeforeUnmount as b, watch as v } from "../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
function D(k = {}, o) {
  const t = y({
    ctrl: !1,
    command: !1,
    win: !1,
    shift: !1,
    tab: !1
  }), { keydown: i, keyup: u } = k, r = (e) => {
    switch (e.key) {
      case "Control":
        t.ctrl = !0;
        break;
      case "Meta":
        t.command = !0, t.win = !0;
        break;
      case "Shift":
        t.shift = !0;
        break;
      case "Tab":
        t.tab = !0;
        break;
    }
    i !== void 0 && Object.keys(i).forEach((a) => {
      if (a !== e.key)
        return;
      const n = i[a];
      if (typeof n == "function")
        n(e);
      else {
        const { stop: d = !1, prevent: l = !1 } = n;
        d && e.stopPropagation(), l && e.preventDefault(), n.handler(e);
      }
    });
  }, f = (e) => {
    switch (e.key) {
      case "Control":
        t.ctrl = !1;
        break;
      case "Meta":
        t.command = !1, t.win = !1;
        break;
      case "Shift":
        t.shift = !1;
        break;
      case "Tab":
        t.tab = !1;
        break;
    }
    u !== void 0 && Object.keys(u).forEach((a) => {
      if (a !== e.key)
        return;
      const n = u[a];
      if (typeof n == "function")
        n(e);
      else {
        const { stop: d = !1, prevent: l = !1 } = n;
        d && e.stopPropagation(), l && e.preventDefault(), n.handler(e);
      }
    });
  }, p = () => {
    (o === void 0 || o.value) && (c("keydown", document, r), c("keyup", document, f)), o !== void 0 && v(o, (e) => {
      e ? (c("keydown", document, r), c("keyup", document, f)) : (s("keydown", document, r), s("keyup", document, f));
    });
  };
  return m() ? (w(p), b(() => {
    (o === void 0 || o.value) && (s("keydown", document, r), s("keyup", document, f));
  })) : p(), h(t);
}
export {
  D as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vooks@0.2.12_vue@3.5.18/~/vooks/es/use-keyboard.js
// module id = 498
// module chunks = 67